<template>
  <div class="customFieldsValuesBySection" v-if="customFields && customFieldValues">
    <!--"Other Values" section on the contact overview-->
    <section v-if="section === 'Other Values' && sectionValues">
      <h3>Other Values</h3>
      <div class="card">
        <div class="card-section">
          <template v-for="customFieldValue in sectionValues">
            <custom-field-value-label-and-value
              :customField="customFieldById(customFieldValue.custom_field_id)"
              :value="customFieldValue.value"
              :key="customFieldValue.id" />
          </template>
        </div>
      </div>
    </section>

    <!--Other sections (on the left-hand side of the contact profile-->
    <section class="custom-field-values-section" :class="sectionClass" v-else-if="sectionValues">
      <template v-for="customFieldValue in sectionValues">
        <custom-field-value-label-and-value
          :customField="customFieldById(customFieldValue.custom_field_id)"
          :value="customFieldValue.value"
          :key="customFieldValue.id" />
      </template>
    </section>
  </div>
</template>

<script>
import { customFieldsQuery } from '../../graphql/customFields'
import CustomFieldValueLabelAndValue from './CustomFieldValueLabelAndValue'

export default {
  components: {
    CustomFieldValueLabelAndValue
  },
  props: {
    section: String, // the section to limit displayed values
    customFieldValues: Array // array of all of the Contact's custom field values
  },
  computed: {
    sectionClass () {
      if (this.section === 'Below Contact Name' || this.section === 'Below Tags') {
        return 'text-center'
      }
      return ''
    },
    sectionValues () {
      // stop if we don't have enough data
      if (!this.customFieldValues || !this.customFields) {
        return null
      }
      // get the custom fields for this section, while sorting by custom field order
      const values = []
      this.sortedCustomFields.forEach(customField => {
        // skip values not in this section
        if (customField.section !== this.section) {
          return
        }
        // get the value for this field
        const value = this.customFieldValues.find(value => value.custom_field_id === customField.id)
        if (value) {
          values.push(value)
        }
      })
      // return the values or null
      return values.length > 0 ? values : null
    },
    sortedCustomFields () {
      if (!this.customFields) {
        return []
      }
      // sort a shallow-copy
      return this.$helpers.sortByKey([...this.customFields], 'sort')
    }
  },
  apollo: {
    customFields: {
      query: customFieldsQuery
    }
  },
  methods: {
    customFieldById (customFieldId) {
      if (!this.customFields) {
        return null
      }
      return this.customFields.find(field => field.id === customFieldId)
    }
  }
}
</script>

<style lang="scss">
.customFieldsValuesBySection {
  .custom-field-values-section {
    margin-bottom: 1em;
  }
}
</style>
